import { ThemedText } from '@/components/themed-text';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View } from 'react-native';

/** Resposta direta do topo (guias e comparativos): o trecho que vira destaque na busca. */
export function AnswerBox({ text }: { text: string }) {
  return (
    <View className="w-full rounded-2xl border border-primary-100 bg-card p-5 md:p-6">
      <View className="mb-2 flex-row items-center gap-2">
        <Ionicons name="flash" size={16} color="#FD5001" />
        <ThemedText className="font-semibold text-sm text-primary">Resposta rápida</ThemedText>
      </View>
      <ThemedText className="text-base text-neutral-700 md:text-lg">{text}</ThemedText>
    </View>
  );
}
